import Breadcrumbs from "@/components/Breadcrumbs";
import { useBreadcrumbs, useMatchMedia, useScrollDirection } from "@/hooks";
import styles from "@/styles/Header.module.scss";
import classnames from "classnames";
import { useEffect, useRef } from "react";
import Stickyfill from "stickyfill";
import HeaderLogo from "./HeaderLogo";
import PrimaryNavigation from "./PrimaryNavigation";
import PrimaryNavigationForSp from "./PrimaryNavigationForSp";
import SecondaryNavigation from "./SecondaryNavigation";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function Header(_ref) {
  let {
    noHeader,
    noTransition
  } = _ref;
  const header = useRef();
  const {
    breadcrumbs
  } = useBreadcrumbs();
  const viewBreadcrumbs = breadcrumbs.length > 0;
  const direction = useScrollDirection(50);
  useEffect(() => {
    if (true && header.current) {
      // IE11 polyfill
      const stickyfill = Stickyfill();
      stickyfill.add(header.current);
    }
  }, [header.current]);
  const mobileSize = useMatchMedia([{
    query: "screen and (max-width: 780px)",
    value: true
  }], false);
  return /*#__PURE__*/_jsx("header", {
    ref: header,
    className: classnames(styles.header, {
      [styles.viewSubHeader]: !mobileSize && viewBreadcrumbs,
      [styles.scrollUp]: direction === "up",
      [styles.scrollDown]: direction === "down"
    }),
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.container,
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.main,
        children: [/*#__PURE__*/_jsx(HeaderLogo, {
          anoTransition: noTransition
        }), !noHeader && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(PrimaryNavigation, {}), /*#__PURE__*/_jsx(SecondaryNavigation, {})]
        })]
      }), !noHeader && /*#__PURE__*/_jsx(PrimaryNavigationForSp, {}), /*#__PURE__*/_jsx("div", {
        className: classnames(styles.sub, {
          hidden: !viewBreadcrumbs || noHeader
        }),
        children: /*#__PURE__*/_jsx(Breadcrumbs, {
          hidden: !viewBreadcrumbs
        })
      })]
    })
  });
}
export default Header;